import React from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import {
  MDBContainer,
  MDBTable,
  MDBTableBody,
  MDBTableHead,
  MDBDataTable,
} from "mdbreact";
import * as misConstantes from "../../../../js/constantes";
import InicioBreadcrumbs from "../../../../pages/template/breadcrumbs/InicioBreadcrumbs.js";
import Select from "react-select";

import {
  Switch,
  Route,
  BrowserRouter,
  Link,
  useLocation,
  useParams,
} from "react-router-dom";

import axios from "axios";

class PreciosCatalogo extends React.Component {
  constructor(props) {
    super(props);

    //				 idSimulador +'/' + idCatalogo + "/" + identificador

    var url = window.location.href;
    var data = url.split("/");
    var idSimulador = data[data.length - 2];
    var idCatalogo = data[data.length - 1];

    var columnas = [
      {
        field: "referencia",
        label: "Referencia",
        attributes: { width: "35%" },
      },
      { field: "producto", label: "Producto", attributes: { width: "50%" } },
      { field: "precio", label: "Precio", attributes: { width: "15%" } },
    ];
    this.state = {
      datos: { columns: columnas, rows: [] },
      proveedores: [],
      idSimulador: idSimulador,
      idCatalogo: idCatalogo,
      catalogo: {},
      linkCatalogo: "",
      simulador: {},
      linkSimulador: "",
      mensajeCargando: "",
    };
  }

  componentDidMount() {
    this.cargarCatalogo();
    this.cargarPrecios();
  }

  render() {
    return (
      <>
        <div
          class="menu"
          style={{
            backgroundColor: "#dbe7fc",
            width: "100%",
            padding: "10px",
            fontSize: "12px",
          }}
        >
          <div class="container">
            <InicioBreadcrumbs></InicioBreadcrumbs> /{" "}
            <a href={"/simuladores"}>Simuladores</a> / Simulador:{" "}
            {this.state.simulador.nombre} / Catálogo:{" "}
            {this.state.catalogo.nombre} / Precios
          </div>
        </div>
        <div
          class="container"
          style={{ minHeight: "550px", paddingTop: "30px" }}
        >
          <div class="subitulosPaginaNotificaciones">
            <b>
              Precios catálogo: Simulador: {this.state.simulador.nombre} -
              Catálogo: {this.state.catalogo.nombre}
            </b>
          </div>
          <br />

          <div style={{ display: this.state.mostrarBotones }}>
            <div class="row">
              <div
                class="col-xl-3 col-lg-3 col-md-4 col-sm-12 col-xs-12"
                style={{ marginBottom: "20px" }}
              >
                <Button
                  variant="primary"
                  style={{ width: "100%" }}
                  onClick={this.descargarFormatoPrecios.bind(this)}
                >
                  <i class="fas fa-plus-circle"></i> Descargar archivo
                </Button>
              </div>
            </div>
          </div>

          <br />
          {this.state.mensajeCargando}
          <br />
          <MDBDataTable
            striped
            bordered
            small
            data={this.state.datos}
            hover
            entriesOptions={[5, 10, 15, 25, 100, 200, 500]}
            entries={100}
            pagesAmount={8}
            condensed
          />
          <br />
          <br />
        </div>
      </>
    );
  }

  // descargarFormatoPrecios(){

  // 	var usuario =  JSON.parse(localStorage.getItem('usuario' ));

  // 	var idCatalogo = this.state.idCatalogo;
  // 	var url = misConstantes.URL_CONSULTA + "/preciosProveedorCatalogo.xlsx?idCatalogo=" + idCatalogo + "&idUsuario=" + usuario.usuario.id;

  // 	window.location.href = url;
  // }

  descargarFormatoPrecios() {
    const usuario = JSON.parse(localStorage.getItem("usuario"));
    const { idCatalogo } = this.state;
    const idUsuario = usuario?.usuario?.id;

    const url = `${misConstantes.URL_CONSULTA}/preciosProveedorCatalogo.xlsx?idCatalogo=${idCatalogo}&idUsuario=${idUsuario}`;

    axios
      .get(url, { responseType: "blob" })
      .then((response) => {
        const blob = new Blob([response.data], {
          type: response.headers["content-type"],
        });
        const urlBlob = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = urlBlob;
        a.download = `preciosProveedor_${idCatalogo}_${idUsuario}.xlsx`;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(urlBlob);
      })
      .catch((error) => {
        console.error(
          "Error al descargar el formato de precios del proveedor:",
          error
        );
      });
  }

  cargarCatalogo() {
    var codigo = localStorage.getItem("simuladores.proveedores.codigoUsuario");
    var idCatalogo = this.state.idCatalogo;
    var info = { codigo: codigo, idCatalogo: idCatalogo };

    axios
      .post(misConstantes.URL_CONSULTA + "/ServletCatalogo", info, {
        params: info,
      })
      .then(
        function (response) {
          var catalogo = response.data;
          var simulador = catalogo.simulador;

          this.setState({ catalogo: catalogo, simulador: simulador });
        }.bind(this)
      )
      .catch(function (error) {});
  }

  cargarPrecios() {
    //
    var columns = this.state.datos.columns;
    var codigo = localStorage.getItem("simuladores.proveedores.codigoUsuario");

    var idCatalogo = this.state.idCatalogo;

    var info = { codigo: codigo, idCatalogo: idCatalogo };

    var datos = { columns: columns, rows: [] };
    this.setState({
      datos: datos,
      mensajeCargando: "Cargando, puede tomar unos segundos",
    });
    axios
      .post(
        misConstantes.URL_CONSULTA +
          "/ServletProductosPrecioProvedorCatalogoProveedor",
        info,
        { params: info }
      )
      .then(
        function (response) {
          var productosPrecioProveedor = response.data;

          var rows = [];
          for (var i = 0; i < productosPrecioProveedor.length; i++) {
            var referencia = productosPrecioProveedor[i].producto.referencia;
            var nombreProducto =
              productosPrecioProveedor[i].producto.descripcion;
            var precio = productosPrecioProveedor[i].sprecio;

            var row = {
              referencia: referencia,
              producto: nombreProducto,
              precio: precio,
              botones: <></>,
            };
            rows.push(row);
          }

          datos = { columns: columns, rows: rows };
          this.setState({ datos: datos, mensajeCargando: "" });
        }.bind(this)
      )
      .catch(function (error) {});
  }
}
export default PreciosCatalogo;
